import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import ReactECharts from "echarts-for-react";


const addValues = (arrays) => {
    if (arrays.length === 0)
        return null;

    const result = Array(arrays[0].length).fill(0);

    arrays.forEach(array => {
        array.forEach((value, index) => {
            result[index] += value;
        });
    });

    return result;

}

function SolarChart(props) {

    const { data, timeAggType } = props;

    const { t } = useTranslation();

    let timestamps = data.timestamps?.map(
        (item) => timeAggType !== "q"? item : (item.replace("Q1", "-01-01").replace("Q2", "-04-01").replace("Q3", "-07-01").replace("Q4", "-10-01"))
    ) ?? [];

    let series = [];

    const solarIrradianceData = addValues(data.data?.filter((t)=>t.metadata.key === "DIRECT_IRRADIANCE").map((t)=>t.values) ?? []);
    const tempData = addValues(data.data?.filter((t)=>t.metadata.key === "OUTSIDE_TEMP").map((t)=>t.values) ?? []);


    series.push({
        name: t("Direct Irradiance") + ' [W/m2]',
        data: solarIrradianceData,
        type:'line',
        symbol: 'none',
        yAxisIndex: 0,
        lineStyle: {
            width: 4
        }
    })
    
    series.push({
        name: t("Outside temperature") + ' [C]',
        data: tempData,
        type:'line',
        symbol: 'none',
        yAxisIndex: 1,
        lineStyle: {
            width: 4
        }
    })


    const solarPoints =  data.meta?.filter((elem) => {
        return elem.key.split("-")[0] === "SOLAR_PRODUCTION"
    }).map((elem) => elem);

    const solarProductionSeries = []

    data.data?.filter((elem)=>elem.metadata.key.split("-")[0] === "SOLAR_PRODUCTION").map((trend)=>{

        series.push({
            name: `${t("Solar Production")} ${trend.metadata.identifier} [kW]`,
            data: trend.values,
            type:'line',
            yAxisIndex: 2,
            symbol: 'none',
            lineStyle: {
                width: 4
            }
        })
        solarProductionSeries.push(`${t("Solar Production")} ${trend.metadata.identifier}`)

    })


    
    let options = {
            tooltip: {
                trigger: "axis",
                valueFormatter: (value) =>
                    typeof value == "number" ? value.toLocaleString(navigator.language,{
                        minimumFractionDigits:2,
                        maximumFractionDigits:2
                    }) : value,
            },
            grid: {
                top: '4%',
                containLabel: true,
                left: '4%',
                right: '5%',
                bottom: 25
                
            },
            legend: {
                show: true,
                bottom: 0, 
                left: "center",
                symbol: 'none'
            },
            xAxis: {
                type: 'category',
                data: timestamps,
                silent: false,
            },
            yAxis: [
                {
                    type: 'value',  
                    position: 'left',  
                    name: 'Direct Irradiance [W/m2]',
                    nameLocation: 'middle',
                    nameGap: 40,
                    axisLine: {
                        show: false 
                    },
                    axisLabel: {
                        formatter: function(value) {
                            return value
                        }
                    },
                    splitLine: { 
                        show: false
                    }
                },
                {
                    type: 'value',  
                    position: 'right',
                    name: 'Outside Temperature [C]',
                    nameLocation: 'middle', 
                    nameGap: 30,
                    axisLabel: {
                        formatter: function(value) {
                            return value;  
                        }
                    },
                    splitLine: { show: false },
                    axisLine: {
                        show: false 
                    },
                },
                {
                    type: 'value',  
                    position: 'right', 
                    offset: 40,   
                    name: 'Solar production [kW]',
                    nameLocation: 'middle',
                    nameGap: 40,
                    axisLabel: {
                        formatter: function(value) {
                            return value;  
                        }
                    },
                    axisLine: {
                        show: false 
                    },
                },
            ],
            textStyle: {
                fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
            },
            series: series,
        };
        

    return (
        <Stack>
            <Typography paddingTop={'25px'} align="center" component="h2" variant="h6" color="primary" gutterBottom>{t("Solar Production")}</Typography>
            {Object.keys(data).length > 1 && <ReactECharts option={options} /> }
        </Stack>
        
    )
};

export default SolarChart;